import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import {
    getApplicantsByJob,
    clearJobError,
} from "../redux/slices/jobSlice";

const ApplicantList = () => {
    const { jobId } = useParams();
    const dispatch = useDispatch();

    const { applicants, error, loading } = useSelector(
        (state) => state.jobs
    );

    console.log("jobId", jobId)

    /* ================= LOAD ================= */
    useEffect(() => {
        dispatch(getApplicantsByJob(jobId));
    }, [dispatch, jobId]);

    /* ================= ERROR (SweetAlert) ================= */
    useEffect(() => {
        if (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error,
            });
            dispatch(clearJobError());
        }
    }, [error, dispatch]);

    /* ================= NEW BADGE ================= */
    const isNewApplicant = (createdAt) => {
        const diff =
            (Date.now() - new Date(createdAt).getTime()) /
            (1000 * 60 * 60);
        return diff <= 24;
    };

    /* ================= SORT ================= */
    const sortedApplicants = useMemo(() => {
        return [...applicants].sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
    }, [applicants]);

    /* ================= CALL ================= */
    const makeCall = (number) => {
        if (!number) return;
        window.location.href = `tel:${number}`;
    };

    /* ================= UI ================= */
    return (
        <div className="container py-4">
            <div className="card shadow-sm">
                <div className="card-header bg-white">
                    <h4 className="mb-0">Applicants</h4>
                </div>

                <div className="card-body p-0">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" />
                        </div>
                    ) : sortedApplicants.length === 0 ? (
                        <p className="text-center py-4 text-muted">
                            No applicants yet
                        </p>
                    ) : (
                        <table className="table table-hover mb-0 align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>Name</th>
                                    <th>Message</th>
                                    <th>Job</th>
                                    <th>Address</th>
                                    <th>Applied On</th>
                                    <th width="120">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedApplicants.map((item) => {
                                    const isNew = isNewApplicant(item.createdAt);

                                    return (
                                        <tr key={item._id}>
                                            <td className="fw-semibold">
                                                {item.serviceman?.user?.name}
                                                {isNew && (
                                                    <span className="badge bg-success ms-2">
                                                        NEW
                                                    </span>
                                                )}
                                            </td>

                                            <td className="text-muted">
                                                {item.message}
                                            </td>

                                            <td>{item.job?.title}</td>

                                            <td className="text-muted">
                                                {item.serviceman?.address},{" "}
                                                {item.serviceman?.city},{" "}
                                                {item.serviceman?.state}
                                            </td>

                                            <td className="text-muted">
                                                {new Date(item.createdAt).toLocaleDateString()}
                                            </td>

                                            <td>
                                                <button
                                                    className="btn btn-sm btn-dark"
                                                    onClick={() =>
                                                        makeCall(item.serviceman?.contactNumber)
                                                    }
                                                >
                                                    Call
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ApplicantList;
